// auth store inner constants

export const ACT_REFRESHTOKEM = 'refreshtokem';
export const ACT_CHANGEPASS = 'changepass';
export const ACT_LOGIN = 'login';
export const ACT_LOGINGOOGLE = 'loginGoogle';
export const ACT_LOGINROUMING = 'loginRouming';
export const ACT_LOGINFACEBOOK = 'loginFacebook';
export const ACT_LOGINMICROSOFT = 'loginMicrosoft';
export const ACT_LOGINAPPLE = 'loginApple';
export const ACT_LOGINECP = 'loginECP';
export const ACT_LOGOUT = 'logout';
export const ACT_SAVELOGIN = 'savelogin';
export const ACT_SAVEAVATAR = 'saveAvatar';

export const GET_LASTLOGINGET = 'lastLoginGet';
export const GET_ISLOGINEDGET = 'isLoginedGet';
export const GET_LOGINUSERGET = 'loginUserGet';
export const GET_AVATAR = 'avatarGet';
export const GET_TOKENSGET = 'tokensGet';
export const GET_ACCESTOKENGET = 'accestokenGet';
export const GET_ACTIONSGET = 'actionsGet';
export const GET_SAVELOGIN = 'savelogin';
export const GET_EMAILUSERGET = 'emailUserGet';
export const GET_ORGGET = 'organizationGet';
export const GET_SESSIONID = 'sessionIdGet';
export const GET_ORGID = 'organizationIdGet';
export const GET_USERMODULES = 'userModulesGet';
export const GET_ORGMODULES = 'orgModulesGet';
export const GET_USERCODE = 'userCodeGet';
export const GET_USERROLE = 'userRoleGet';

export const MUT_LOGIN = 'loginDataSet';
export const MUT_LOGOUT = 'logout';
export const MUT_SAVELOGIN = 'savelogin';
export const MUT_AVATAR = 'saveAvatar';
export const MUT_USERNAME = 'updateUserName';
